module.exports = __webpack_public_path__ + "static/media/avatar.e5873563.png";